const Oidc = require('oidc-client-ts'),
    WellboreRightCollection = require('shared/model/wellboreRightCollection');

const signInChannel = Backbone.Radio.channel('signIn');

Oidc.Log.setLogger(console);

class AuthMgr {
    constructor() {
        this.oidcMgr = new Oidc.UserManager({
            userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
            authority: process.env.AUTHORITY,
            client_id: 'welldrive.js',
            redirect_uri: `${process.env.APP_ROOT}/#signInCallback`,
            response_type: 'code',
            scope: 'openid profile WD.API',
            post_logout_redirect_uri: `${process.env.APP_ROOT}/#signOutCallback`,
            loadUserInfo: true,
            response_mode: 'query',
        });
        this.oidcMgr.events.addAccessTokenExpiring(function () {
            console.info('token expiring...');
        });
        this.oidcMgr.events.addUserLoaded(function () {
            console.info('user loaded...');
        });
        this.oidcMgr.events.addUserUnloaded(function () {
            console.info('user unloaded...');
        });
        this.oidcMgr.events.addAccessTokenExpired(function () {
            console.info('access token expired...');
        });

        this.user = null;
        this.wellboreRights = null;
    }

    // Async 
    async initializeAuthData() {
        this.user = await this.oidcMgr.getUser();
    }
    async signIn(postSignInRoute) {
        await this.oidcMgr.signinRedirect({
            state: {
                postSignInRoute
            }
        });
    }
    async signInCallback() {
        // Identity server redirect url configuration is limited to a static string that will get a query string appended to it.
        // This causes problems with our fragment based routing because it isn't quite flexible enough to allow for a well formed
        // url that has both a query string and fragment (since the fragment is supposed to go after the search). 
        // oidc-client-ts doesn't tollerate this break in protocol, so to get around this, the fragment is stripped out of the redirect uri altogether.
        let url = window.location.href.replace('#signInCallback', '');
        return await this.oidcMgr.signinCallback(url)
            .then(this.onSuccessfulSignIn.bind(this))
            .catch(error => {
                console.error(error);
                window.location.href = 'login.html';
            });
    }
    onSuccessfulSignIn(user) {
        this.user = user;
        signInChannel.trigger('signIn', this.user);
        if (user.state.postSignInRoute) {
            window.location.href = `/#${user.state.postSignInRoute}`;
        }
        else {
            window.location.href = '/#wellbore';
        }
        // set user for faro logging
        if (window.faro) {
        window.faro.api.setUser({
            id: user.profile.userId,
            username: user.profile.userName
        });
        }
    }
    async signOut(route) {
        this.user = null;
        this.wellboreRights = null;
        await this.oidcMgr.removeUser();
        if (route) {
            window.location.href = `login.html?${route}`;
        }
    }

    // Sync - use these only after auth data has been loaded via signIn or initializeAuthData
    isAuthenticated() { return this.user && !this.user.expired }
    getAuthHeader() {
        if (this.isAuthenticated()) {
            return `Bearer ${this.user.access_token}`
        }
    }
    hasRight(right, useWellboreRights = false) {
        if (!this.isAuthenticated()) {
            return false;
        }
        // TODO:
        // Review need for this 'any' case.
        if (right.toLowerCase() === 'any') {
            return true;
        }
        const rightsToTest = useWellboreRights ? this.wellboreRights : this.user.profile.rights.split(',');
        return _.some(rightsToTest, function (testRight) {
            if (right.toLowerCase() === 'itadmin') {
                return testRight.toLowerCase() === right.toLowerCase();
            }
            else if (right.toLowerCase() === 'ops') {
                return testRight.toLowerCase() === right.toLowerCase();
            }
            else if (right.toLowerCase() === 'sitemanager') {
                return testRight.toLowerCase() === right.toLowerCase();
            }
            else if (right.toLowerCase() === 'entrycontactrequired') {
                return testRight.toLowerCase() === right.toLowerCase();
            }
            return testRight.toLowerCase() === right.toLowerCase() || testRight.toLowerCase() === 'all' || testRight.toLowerCase() === 'siteadmin';
        });
    }
    getUserProperty(propertyName) {
        return this.user.profile[propertyName]
    }
    getRights(useWellboreRights = false) {
        return useWellboreRights ? this.wellboreRights.slice() : _rights.slice();
    }
    // Used by loadDataController to fetch wellbore-specific rights from the server for the current user.
    loadWellboreAuthorization(wellboreId) {
        const rightCollection = new WellboreRightCollection(null, {
            wellboreId: wellboreId
        });
        return rightCollection.fetch()
            .done(function () {
                this.setWellboreRights(rightCollection.map((right) => right.get('name')));
            }.bind(this));
    }
    loadWellboreAuthorizationByEntry(entryId) {
        const rightCollection = new WellboreRightCollection(null, {
            entryId: entryId
        });
        return rightCollection.fetch()
            .done(function () {
                this.setWellboreRights(rightCollection.map((right) => right.get('name')))
            }.bind(this));
    }
    setWellboreRights(rights) {
        this.wellboreRights = rights;
    }
}

module.exports = new AuthMgr();
